import { TestIdDomain } from 'constants/testIds';

const ChannelsTestIdsScope = {
  CHANNEL_FORM: 'channel-form',
};

export const ChannelsTestIds = {
  CHANNEL_FORM: `${TestIdDomain.CHANNELS}.form`,
  CHANNEL_FORM_DELETE_EXTENSION_SETTING_BUTTON: `${ChannelsTestIdsScope.CHANNEL_FORM}.delete-extension-setting-button`,
  CHANNEL_FORM_DELETE_LOCK_DESK_EXTENSION_SETTING_BUTTON: `${ChannelsTestIdsScope.CHANNEL_FORM}.delete-lock-desk-extension-setting-button`,
  CHANNEL_FORM_SUBMIT_BUTTON: `${ChannelsTestIdsScope.CHANNEL_FORM}.submit-button`,
  CHANNEL_FORM_NAME_INPUT: `${ChannelsTestIdsScope.CHANNEL_FORM}.name-input`,
  CHANNEL_FORM_TABS: `${ChannelsTestIdsScope.CHANNEL_FORM}.tabs`,
  CHANNEL_FORM_INTAKE_METHOD: `${ChannelsTestIdsScope.CHANNEL_FORM}.intake-method`,
  CHANNEL_FORM_PRICING_STEP_SWITCH: `${ChannelsTestIdsScope.CHANNEL_FORM}.pricing-step-switch`,
  CHANNEL_FORM_DISCLOSURE_STEP_SWITCH: `${ChannelsTestIdsScope.CHANNEL_FORM}.disclosure-step-switch`,
  CHANNEL_FORM_CONDITIONS_STEP_SWITCH: `${ChannelsTestIdsScope.CHANNEL_FORM}.conditions-step-switch`,
  CHANNEL_FORM_LOCK_STEP_SWITCH: `${ChannelsTestIdsScope.CHANNEL_FORM}.lock-step-switch`,
  CHANNEL_FORM_AUS_REQUIREMENT: `${ChannelsTestIdsScope.CHANNEL_FORM}.aus-requirement`,
  CHANNEL_FORM_AUS_COMPLETION: `${ChannelsTestIdsScope.CHANNEL_FORM}.aus-completion`,
  CHANNEL_FORM_TERMINAL_ACTION: `${ChannelsTestIdsScope.CHANNEL_FORM}.terminal-action`,
  CHANNEL_FORM_REQUIRED_DOC_SET: `${ChannelsTestIdsScope.CHANNEL_FORM}.required-doc-set`,
  CHANNEL_FORM_SECTION_VISIBILITIES: `${ChannelsTestIdsScope.CHANNEL_FORM}.section-visibilities`,
  CHANNEL_FORM_PATH_STEPS_LIST: `${ChannelsTestIdsScope.CHANNEL_FORM}.path-steps-list`,

  // Dynamic
  getPathStepDragHandleId: stepKey =>
    `${ChannelsTestIdsScope.CHANNEL_FORM}.path-step-${stepKey}-drag-handle`,

  // ChannelsList
  ADD_CHANNEL_BUTTON: `${TestIdDomain.CHANNELS}.add-button`,
  CHANNELS_TABLE: `${TestIdDomain.CHANNELS}.table`,
  CHANNELS_EMPTY: `${TestIdDomain.CHANNELS}.empty`,
  getChannelRowId: channelId => `${TestIdDomain.CHANNELS}.channel-${channelId}`,
  getChannelStatusId: channelId => `${TestIdDomain.CHANNELS}.channel-${channelId}-status`,
  getChannelProgramsId: channelId => `${TestIdDomain.CHANNELS}.channel-${channelId}-programs`,
  getChannelEditButtonId: channelId => `${TestIdDomain.CHANNELS}.channel-${channelId}-edit-button`,
  getChannelCustomizedId: channelId => `${TestIdDomain.CHANNELS}.channel-${channelId}-customized`,

  // ChannelsForm (fields)
  CHANNEL_FORM_ACCOUNTING_CLASS_SELECT: `${ChannelsTestIdsScope.CHANNEL_FORM}.accounting-class-select`,
  CHANNEL_FORM_LOCK_DESK_MORTGAGE_TYPE_SELECT: `${ChannelsTestIdsScope.CHANNEL_FORM}.lock-desk-mortgage-type-select`,
  CHANNEL_FORM_EXTENSION_LLPA_TYPE_SELECT: `${ChannelsTestIdsScope.CHANNEL_FORM}.extension-llpa-type-select`,
  CHANNEL_FORM_FLOAT_DOWN_LLPA_TYPE_SELECT: `${ChannelsTestIdsScope.CHANNEL_FORM}.float-down-llpa-type-select`,
};
